import "./FilDarian.css";
import React from "react";
import { Nav } from "react-bootstrap";
import {  NavLink } from "react-router-dom";
import { RxPerson } from "react-icons/rx";
import {
  COURS_ADMIN_NAVIGATION,
  USERS_ADMIN_NAVIGATION,
  PROFIL_ADMIN_NAVIGATION,
  PARAMETRE_ADMIN_NAVIGATION,
} from "../../Routes/NAVIGATION_PATH";

function FilDarian({nom1,nom2,route1,route2}) {
  return (
    <div id="filDarian">      
        <div className=" d-flex " >
          <NavLink to={route1}  className="link23 ">{nom1}</NavLink>
          <NavLink to={route2}   className="link23">{nom2}</NavLink>
        </div>
        <hr />
    </div>
  );
};

export default FilDarian;
